/**
 * Information from URL.
 * Contains a regex to match the target URL against.
 * Contains an 'infoTr' key that holds the localization for the URL's usage.
 * @type {Array}
 */
export const allSyncableUrlInfo = [
  {
    method: 'post',
    url: /\/server\/problems/,
    infoTr: 'message.NETWORK_MGR_CREATE_PROBLEM',
  },
  {
    method: 'put',
    url: /\/server\/problems\/\d+/,
    infoTr: 'message.NETWORK_MGR_UPDATE_PROBLEM',
  },
  {
    method: 'delete',
    url: /\/server\/problems\/\d+/,
    infoTr: 'message.NETWORK_MGR_DELETE_PROBLEM',
  },
  // TODO remove after testing
  {
    method: 'post',
    url: /\/legacy\/actionPlans\/get.php/,
    infoTr: 'message.NETWORK_MGR_FETCH_ACTION-PLANS',
  },
];

const allUrlLength = allSyncableUrlInfo.length;

/**
 * Find the information object about a URL, based on allSyncableUrlInfo.
 * @param  {String} url  The URL to find info about
 * @return {Object}  Info about the URL or null if none found.
 */
export function urlMatchesInfoObject(config) {
  for (let i = 0; i < allUrlLength; i++) {
    const info = allSyncableUrlInfo[i];
    if (info.url.test(config.url) && config.method === info.method) {
      config.info = info;
      return config;
    }
  }
  return config;
}

export default {
  allSyncableUrlInfo,
  urlMatchesInfoObject,
};
